import React from 'react';
import { Sparkles, Home, Heart } from 'lucide-react';
import florLogo from '../assets/florDaisiesSF.png';
import letrasLogo from '../assets/daisies_letras.png';

const WelcomeOnboarding = ({ user, onSelectMembership, onGoHome }) => {
  const firstName = (user?.nombre || '').split(' ')[0] || '';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-daisies via-purple-600 to-purple-800 px-4 py-8 overflow-y-auto">
      {/* Decorative blurred orbs */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-pink-300/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/3 right-1/4 w-48 h-48 bg-purple-300/20 rounded-full blur-2xl pointer-events-none" />

      <div className="relative z-10 max-w-md w-full bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 md:p-10 text-center animate-fadeIn">
        {/* Hero illustration: floating flower with halo */}
        <div className="relative mb-6">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 bg-gradient-to-br from-daisies/20 to-purple-300/30 rounded-full blur-2xl animate-pulse" />
          </div>
          <div className="relative flex justify-center">
            <div className="w-24 h-24 bg-gradient-to-br from-daisies-50 to-purple-100 rounded-full flex items-center justify-center shadow-soft">
              <img src={florLogo} alt="Daisies" className="h-14 w-auto" />
            </div>
          </div>
          {/* Sparkles around */}
          <Sparkles className="absolute top-0 right-1/3 text-yellow-400 animate-pulse" size={18} />
          <Sparkles className="absolute bottom-0 left-1/3 text-pink-400 animate-pulse" size={14} style={{ animationDelay: '0.5s' }} />
          <Heart className="absolute top-1/2 left-0 text-pink-300 fill-pink-300 animate-pulse" size={16} style={{ animationDelay: '1s' }} />
        </div>

        <div className="flex justify-center mb-5">
          <img src={letrasLogo} alt="Daisies" className="h-7 w-auto opacity-80" />
        </div>

        <h1 className="text-3xl md:text-[2rem] font-bold text-text-primary mb-3 tracking-tight leading-tight">
          {firstName ? <>¡Bienvenida, <span className="text-daisies">{firstName}</span>!</> : '¡Bienvenida!'}
        </h1>
        <p className="text-base text-text-secondary mb-8 leading-relaxed px-2">
          Estamos felices de tenerte aquí. Tu cuenta ya está lista — empieza con una membresía y cuida tu salud sin complicaciones.
        </p>

        {/* Membership highlight */}
        <div className="bg-brand-tint rounded-2xl p-5 mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Sparkles className="text-daisies" size={18} />
            <p className="text-xs font-bold uppercase tracking-wider text-daisies">Recomendado</p>
          </div>
          <p className="text-sm text-text-secondary leading-relaxed">
            Con la membresía mensual ahorras hasta <strong className="text-daisies">$51 por consulta</strong> y tienes acceso a todas las especialidades incluidas.
          </p>
        </div>

        <button
          onClick={onSelectMembership}
          className="press-scale w-full py-4 bg-daisies text-white rounded-full font-bold text-base hover:bg-daisies-hover transition-all shadow-elevated hover:shadow-soft flex items-center justify-center gap-2 mb-3"
        >
          <Sparkles size={18} />
          Comprar membresía
        </button>

        <button
          onClick={onGoHome}
          className="press-scale w-full py-3 text-text-secondary hover:text-daisies transition-all flex items-center justify-center gap-2 text-sm font-medium"
        >
          <Home size={16} />
          Continuar al inicio
        </button>
      </div>
    </div>
  );
};

export default WelcomeOnboarding;
